import { Phone, MapPin, Clock, Mail } from "lucide-react";

export default function ContactPage() {
  return (
    <div data-testid="contact-page" className="text-white">
      <section className="relative border-b border-neutral-900 py-20 px-6 lg:px-10">
        <div className="absolute inset-0 kk-grid-bg opacity-40" />
        <div className="relative max-w-7xl mx-auto">
          <div className="text-xs uppercase tracking-[0.3em] text-[#00E5FF] mb-4">// Contact</div>
          <h1 className="font-display text-5xl sm:text-7xl uppercase leading-none">
            Ne <span className="text-[#00E5FF]">gasesti</span> aici.
          </h1>
        </div>
      </section>

      <section className="py-16 px-6 lg:px-10 max-w-7xl mx-auto grid lg:grid-cols-2 gap-10">
        <div className="space-y-4">
          <ContactItem icon={Phone} title="Telefon" value="0743 110 277" href="tel:0743110277" testid="contact-phone" />
          <ContactItem icon={MapPin} title="Adresa" value="Bulevardul Liviu Rebreanu 104A, Timisoara, Timis" testid="contact-address" />
          <ContactItem icon={Clock} title="Program" value="Luni - Vineri: 9:00 - 17:00 · Sambata: 9:00 - 14:00" testid="contact-hours" />
          <ContactItem icon={Mail} title="Partener oficial" value="trotinete-ieftine.ro" testid="contact-partner" />
        </div>
        <div className="aspect-video lg:aspect-auto bg-neutral-900 border border-neutral-800 overflow-hidden">
          <iframe
            title="Locatie TROTI-X SERVICE"
            src="https://www.google.com/maps?q=Bulevardul+Liviu+Rebreanu+104A,+Timisoara,+Timis&output=embed"
            className="w-full h-full min-h-[400px]"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </section>
    </div>
  );
}

const ContactItem = ({ icon: Icon, title, value, href, testid }) => {
  const inner = (
    <div data-testid={testid} className="flex items-start gap-4 bg-neutral-950 border border-neutral-800 hover:border-[#00E5FF] p-6 transition-colors">
      <div className="w-11 h-11 bg-[#00E5FF]/10 border border-[#00E5FF]/30 flex items-center justify-center">
        <Icon className="w-5 h-5 text-[#00E5FF]" />
      </div>
      <div>
        <div className="text-xs uppercase tracking-widest text-neutral-500">{title}</div>
        <div className="text-lg font-medium mt-1">{value}</div>
      </div>
    </div>
  );
  return href ? <a href={href}>{inner}</a> : inner;
};
